import { useState, useEffect, useCallback } from "react";
import { AlertCircle, X } from "lucide-react";

interface ErrorBannerProps {
  message: string | null;
  onDismiss?: () => void;
}

export function ErrorBanner({ message, onDismiss }: ErrorBannerProps) {
  if (!message) return null;
  return (
    <div
      className="card"
      style={{
        marginBottom: "var(--space-4)",
        borderColor: "var(--red)",
        background: "var(--red-soft)",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "10px 14px",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 8, color: "var(--red)", fontSize: 13, fontWeight: 600 }}>
        <AlertCircle size={16} />
        <span>{message}</span>
      </div>
      {onDismiss && (
        <button
          onClick={onDismiss}
          style={{
            background: "transparent",
            color: "var(--red)",
            padding: "2px 6px",
            fontSize: 16,
            lineHeight: 1,
            border: "none",
          }}
          aria-label="닫기"
        >
          <X size={16} />
        </button>
      )}
    </div>
  );
}

export function useApiError() {
  const [error, setError] = useState<string | null>(null);

  const wrap = useCallback(async <T,>(fn: () => Promise<T>): Promise<T | null> => {
    try {
      setError(null);
      return await fn();
    } catch (e: any) {
      setError(e?.message ?? "API 요청 처리 중 오류가 발생했습니다.");
      return null;
    }
  }, []);

  useEffect(() => {
    if (error) {
      const timer = setTimeout(() => setError(null), 10000);
      return () => clearTimeout(timer);
    }
  }, [error]);

  return { error, setError, wrap };
}
